import { useEffect } from 'react'

const POLL_INTERVAL = 2000

export function useQueuePolling(
  enabled: boolean,
  startPolling: (pollInterval: number) => void,
  stopPolling: () => void
) {
  useEffect(() => {
    if (!enabled) return

    startPolling(POLL_INTERVAL)
    /*
     * Returning the function registers it as React's cleanup; React calls it
     * when a dependency changes or the component unmounts.
     */
    return stopPolling
  }, [enabled, startPolling, stopPolling])
}
